import axios from 'axios';
import urlConfigs from './urlConfigs';
import store from '../store';
import { setSessionExpired } from '../slices/authSlice';
import { cacheGet } from './cache';
import { RefreshTokenCreateService } from '../services/auth.service';

const BaseApiUrl = process.env.REACT_APP_API_URL;
const clientId = process.env.REACT_APP_API_CLIENTID

const axiosInstance = axios.create({
  baseURL: BaseApiUrl,
});

axiosInstance.interceptors.response.use(
  async (response) => response,
  async error => {
    if (error.response) {
      if (error?.response?.status === 401 && error?.response?.data?.error === "Token is expired, login again." || error?.response?.data?.error === "Invalid token") {
        const currentPath = window.location.pathname + window.location.search;
        sessionStorage.removeItem('token')
        window.location.href = "/signin";
        const apiToken = JSON.parse(localStorage.getItem("apiToken"))
        const role = apiToken.userRole
        const associate = apiToken?.associateId
        let deepLink = {
          currentPath: currentPath,
          role: role,
          associateId: associate
        };
        sessionStorage.setItem('deepLink', JSON.stringify(deepLink));
        store.dispatch(setSessionExpired(true));

      }
    }
    return Promise.reject(error);
  }
);


export const postCall = async (postData = {}) => {


  let url = BaseApiUrl;
  let bodyData = {}, headers = {
    "Content-Type": "application/json"
  };

  if (postData.accessToken && postData.accessToken === 'false') {
    delete headers['accessToken'];
  }

  if (!!sessionStorage.getItem('token')) {
    // headers['Authorization'] = `Bearer ${sessionStorage.getItem('token')}`;
    const rawToken = sessionStorage.getItem('token');
    const cleanToken = rawToken?.replace(/^"|"$/g, '');
    headers['Authorization'] = `Bearer ${cleanToken}`;
  }

  if (postData.bodyData) {
    bodyData = postData.bodyData;
  }

  if (postData.header) {
    headers = { ...headers, ...postData.header };
  }

  if (postData.fullUrl) {
    url = postData.fullUrl;
  }

  if (postData.url) {
    url += urlConfigs[postData.url];
  }

  if (postData.callBackData) {
    postData.bodyData['callBackData'] = postData.callBackData;
  }
  if (Object.keys(headers).length > 0) {
    headers['clientId'] = clientId;
  }
  return await axiosInstance.post(url, bodyData, {
    headers: headers
  })
    .then(response => {
      postData.successCallBack && postData.successCallBack(response, postData.bodyData);
      return response;
    })
    .catch(error => {

      postData.errorCallBack && postData.errorCallBack(error);
      return error;
    });

};

export const putCall = async (putData = {}) => {

  let url = BaseApiUrl;
  let bodyData = {}, headers = {
    "Content-Type": "application/json"
  };

  if (putData.accessToken && putData.accessToken === 'false') {
    delete headers['accessToken'];
  } else if (putData.accessToken && putData.accessToken) {
    headers['accessToken'] = putData.accessToken;
  }

  if (putData.bodyData) {
    bodyData = putData.bodyData;
  }

  if (!!sessionStorage.getItem('token')) {
    // headers['Authorization'] = `Bearer ${sessionStorage.getItem('token')}`;
    const rawToken = sessionStorage.getItem('token');
    const cleanToken = rawToken?.replace(/^"|"$/g, '');
    headers['Authorization'] = `Bearer ${cleanToken}`;
  }

  if (putData.header) {
    headers = { ...headers, ...putData.headers };
  }

  if (putData.fullUrl) {
    url = putData.fullUrl;
  }

  if (putData.url) {
    url += urlConfigs[putData.url];
  }

  if (Object.keys(headers).length > 0) {
    headers['clientId'] = clientId;
  }
  return axiosInstance.put(url, bodyData, {
    headers: headers
  })
    .then(response => {
      putData.successCallBack && putData.successCallBack(response);
      return response;
    })
    .catch(error => {
      putData.errorCallBack && putData.errorCallBack(error);
      return error;
    });
};

export const getCall = async (getData = {}) => {

  let url = BaseApiUrl;
  let headers = {
    "Content-Type": "application/json"
  };

  let axiosPayload = { headers };

  if (getData.accessToken && getData.accessToken === 'false') {
    delete headers['accessToken'];
  } else if (getData.accessToken && getData.accessToken) {
    headers['accessToken'] = getData.accessToken;
  }

  if (sessionStorage.getItem('token')) {
    // headers['Authorization'] = `Bearer ${sessionStorage.getItem('token')}`;
    const rawToken = sessionStorage.getItem('token');
    const cleanToken = rawToken?.replace(/^"|"$/g, '');
    headers['Authorization'] = `Bearer ${cleanToken}`;
  }

  if (getData.urlParams) {
    axiosPayload.params = getData.urlParams;
  }

  if (getData.header) {
    axiosPayload.headers = { ...headers, ...getData.header };
  }

  if (Object.keys(axiosPayload?.headers).length > 0) {
    axiosPayload.headers['clientId'] = clientId;
  }

  if (getData.fullUrl) {
    url = getData.fullUrl;
  }

  if (getData.url) {
    url += urlConfigs[getData.url];
  }


  return await axiosInstance.get(url, axiosPayload)
    .then(response => {
      getData.successCallBack && getData.successCallBack(response, getData);
      return response;
    })
    .catch(error => {
      getData.errorCallBack && getData.errorCallBack(error);
      return error;
    });
};

export const deleteCall = async (deleteData = {}) => {
  let url = BaseApiUrl;
  let bodyData = {}, headers = {
    "Content-Type": "application/x-www-form-urlencoded"
  };

  let payload = { headers };

  if (deleteData.accessToken && deleteData.accessToken === 'false') {
    delete headers['accessToken'];
  } else if (deleteData.accessToken && deleteData.accessToken) {
    headers['accessToken'] = deleteData.accessToken;
  }

  if (!!sessionStorage.getItem('token')) {
    // headers['Authorization'] = `Bearer ${sessionStorage.getItem('token')}`;
    const rawToken = sessionStorage.getItem('token');
    const cleanToken = rawToken?.replace(/^"|"$/g, '');
    headers['Authorization'] = `Bearer ${cleanToken}`;
  }

  if (deleteData.urlParams) {
    payload.params = deleteData.urlParams;
  }

  if (deleteData.bodyData) {
    payload.data = { ...bodyData, ...deleteData.bodyData };
  }

  if (deleteData.header) {
    payload.headers = { ...headers, ...deleteData.headers };
  }
  if (Object.keys(payload?.headers).length > 0) {
    payload.headers['clientId'] = clientId;
  }
  if (deleteData.fullUrl) {
    url = deleteData.fullUrl;
  }

  if (deleteData.url) {
    url += urlConfigs[deleteData.url];
  }

  return await axiosInstance.delete(url, payload).then(response => {
    deleteData.successCallBack && deleteData.successCallBack(response, deleteData);
    return response;
  }).catch(error => {
    deleteData.errorCallBack && deleteData.errorCallBack(error, deleteData);
    return error
  });
};